import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const alignToClassNameMap = {
  center: 'cuiTextBlock--center',
};

export const ALIGN = Object.keys(alignToClassNameMap);

export const CuiTextBlock = ({ children, className, align, ...rest }) => {
  const classes = classNames(
    'cuiTextBlock',
    className,
    alignToClassNameMap[align]
  );
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

CuiTextBlock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  align: PropTypes.oneOf(ALIGN),
};

CuiTextBlock.defaultProps = {
  children: undefined,
  className: undefined,
  align: undefined,
};



// WEBPACK FOOTER //
// ./ui/components/typography/TextBlock.js